module.exports = __webpack_public_path__ + "static/media/TreeLion.81db056e.png";